angular.module('env.data.repos.documents', [])

    .service("documentsRepository", function (rest) {
        var _this = this;
        var modelType = "DocumentModel";
        var modelDefinition = rest.getDefinition(modelType);

        var customFieldAwareType = "CustomFieldAwareModel";
        var customFieldAwareDef = rest.getDefinition(customFieldAwareType);

        /**
         * Get document by id
         * @param {string} id id of the document
         * @returns {!Promise.<RepresentationModel>} Promise of document
         */
        _this.getDocument = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        _this.initUpload = function (initUploadModel) {
            return rest.map(modelDefinition).map("init-upload").post(initUploadModel);
        }

        _this.uploadData = function (data, config) {
            return rest.map(modelDefinition).map("upload-data").post(data, config);
        }

        /**
         * Save document's custom fields
         * @param {RepresentationModel} document Document Model which custom fields has to be saved
         */
        _this.saveDocumentCustomFields = function (document) {

            var customFields = _.find(customFieldAwareDef.getFields(), function (fieldDef) {
                return fieldDef.name === "customFields";
            });
            if (angular.isDefined(customFields)) {
                customFields.save(rest, document);
            }
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("DocumentModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
        requestCoupler.addCoupler(requestCouplerUtils.createCustomFieldsCollectionCoupler(modelUrl, "customfields", baserUrl + "/" + modelUrl + "/customfields"));
    })

;
